// Core
import React from "react";

// Styles
import "./styles.scss";

// Custom components
import Button from "../Button";

const Assessment = ({
  labeltype,
  headingName,
  assessmentName,
  referenceName,
  plannedDate,
  dueDate,
  assessorName,
  completionPercentage,
  handleOnclick,
}) => {
  // Define a function to map completion percentage to class names
  const getStatusClass = () => {
    let statusClass = "preassessment-status"; // base class
    if (completionPercentage === 0) {
      statusClass += " pending";
    } else if (completionPercentage > 0 && completionPercentage < 100) {
      statusClass += " in-progress";
    } else if (completionPercentage === 100) {
      statusClass += " completed";
    }
    return statusClass;
  };

  // Function to determine button title based on completion percentage
  const getButtonTitle = () => {
    if (completionPercentage === 0) {
      return "Take Pre-Assessment";
    } else if (completionPercentage > 0 && completionPercentage < 100) {
      return "Continue Pre-Assessment";
    } else if (completionPercentage === 100) {
      return "View Pre-Assessment";
    }
    return "Take Assessment";
  };

  return (
    <div className="schedule-assessment-container">
      <div className="assessment">
        <div>
          {headingName && (
            <h3 className="assessment-con-title">{headingName}</h3>
          )}
          <div className="assessment-details">
            <h4 className="assessment-con-heading">{assessmentName ?? "-"}</h4>
            <div className={getStatusClass()}>
              {completionPercentage === 0
                ? "Pending"
                : completionPercentage === 100
                ? "Completed"
                : "In-progress"}
            </div>
          </div>      
          <div className="assessment-info">
  <div className="assessment-info-details">
    <p>
      <span className="label" style={{width:"200px"}}>{labeltype ? "Start Date" : "Planned Assessment Date"}</span>
      <strong>: {plannedDate}</strong>
    </p>
    <p>
      <span className="label">KG Assessor</span>
      <strong>: {assessorName ?? "-"}</strong>
    </p>
    <p>
      <span className="label" style={{width:"200px"}}>{labeltype ? "Due Date" : "Pre Assessment Due Date"}</span>
      <strong>: {dueDate}</strong>
    </p>
  </div>

  <div className="assessment-info-details">
    <p className="reference">
      <span className="label" style={{width:"200px"}}>Reference Number</span>
      <strong>: {referenceName || "-"}</strong>
    </p>
  </div>
</div>

        </div>
        <div
          className={
            labeltype ? "assessment-actions-reverse" : "assement-actiovs"
          }
        >
          <Button
            title={getButtonTitle()}
            buttonStyle={{ width: "17vw", padding: "15px 10px" }}
            disabled={completionPercentage === 100}
            onClick={() => handleOnclick()}
            titleStyle={{ fontSize: "1rem", color: "white" }}
          />
          <p className="completion-percentage">
            {completionPercentage} % Completed
          </p>
        </div>
      </div>
    </div>
  );
};

export default Assessment;
